<template>
  <label class="custom-checkbox-container" :for="uniqueId">
    <input
      type="checkbox"
      :id="uniqueId"
      :checked="value"
      @change="$emit('input', $event.target.checked)"
      class="native-checkbox"
    />
    <span class="checkbox-visual" :class="{ checked: value }">
      <!-- Checkmark SVG is only rendered if 'value' (checked state) is true -->
      <svg
        v-if="value"
        class="checkmark-icon"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19,6 L10,16 L4,10"
          stroke="white"
          stroke-width="3"
        />
      </svg>
    </span>
    <span class="checkbox-label">
      {{ label }}
    </span>
  </label>
</template>

<script>
let idCounter = 0;

export default {
  name: 'CustomCheckbox',
  props: {
    value: { // For v-model in Vue 2
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
  
    id: {
      type: String,
      default: null
    }
  },
  data: function() {
    return {
      uniqueId: this.id || 'custom-checkbox-' + idCounter++,
    };
  }
};
</script>

<style scoped>
.custom-checkbox-container {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  /* Using a common system font stack that resembles iOS fonts */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 22px; /* Adjusted to visually match the image's text size */
  user-select: none;
}


.native-checkbox {
  /* Hide native checkbox but keep it accessible */
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}

.checkbox-visual {
  width: 18px;         /* Width of the square box */
  height: 18px;        /* Height of the square box */
  /* Unchecked state: Transparent background, grey border */
  background-color: transparent; /* Ensures no fill color when unchecked */
  border: 1px solid #8A8A8F;    /* Neutral grey border (iOS secondary interface color) */
  border-radius: 1px;           /* Rounded corners like in the image */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s, border-color 0.2s;
  margin-right: 10px;          /* Space between the box and the label text */
}

.checkbox-visual.checked {
  /* Checked state: Green background and border */
  background-color: #34C759; /* iOS system green */
  border-color: #34C759;
}

.checkmark-icon {
  width: 20px;  /* Size of the checkmark */
  height: 20px; /* Size of the checkmark */
  stroke: white; /* Color of the checkmark lines */
}

.checkbox-label {
  color: var(--color-gray-100); 
  transition: color 0.2s;
  font-size: var(--font-s);
}


/* Accessibility: Style for when the hidden native checkbox is focused */
.native-checkbox:focus + .checkbox-visual {
  outline: 2px solid #0A84FF; /* iOS system blue for focus ring */
  outline-offset: 2px;
}
</style>